// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 900px) {
  .wizard-image {
    display: none;
  }

  .summary-container {
    width: 100%;
  }

}

.summary-container {
  max-width: 500px;
}
/* @media screen and (min-width:900px) and (max-width: 1024px) {
  .newflexcol,.flexcol{width: 46%;}

} */


.wizard-image img {

  /* margin-right: -200%; */
  max-width: 400px; height: auto
}


.slideInAnimation {
  position: absolute;
  z-index: -1;
  right: -50%;
  top: 50%;
  transform: translate(50%,-50%) scaleX(-1);
  animation: slidein 4s forwards;
}

.slideOutAnimation {
  animation: slideout 6s forwards;
}


@keyframes slidein {
  100% { right: 250px; }
}


@keyframes slideout {
  0% { right: 250px; }
  100% { right: 50%; }
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndpemFyZC1zdW1tYXJ5LmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtJQUNFLGFBQWE7RUFDZjs7RUFFQTtJQUNFLFdBQVc7RUFDYjs7QUFFRjs7QUFFQTtFQUNFLGdCQUFnQjtBQUNsQjtBQUNBOzs7R0FHRzs7O0FBR0g7O0VBRUUseUJBQXlCO0VBQ3pCLGdCQUFnQixFQUFFO0FBQ3BCOzs7QUFHQTtFQUNFLGtCQUFrQjtFQUNsQixXQUFXO0VBQ1gsV0FBVztFQUNYLFFBQVE7RUFDUix5Q0FBeUM7RUFFekMsOEJBQThCO0FBQ2hDOztBQUVBO0VBRUUsK0JBQStCO0FBQ2pDOzs7QUFHQTtFQUNFLE9BQU8sWUFBWSxFQUFFO0FBQ3ZCOzs7QUFHQTtFQUNFLEtBQUssWUFBWSxFQUFFO0VBQ25CLE9BQU8sVUFBVSxFQUFFO0FBQ3JCIiwiZmlsZSI6IndpemFyZC1zdW1tYXJ5LmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiA5MDBweCkge1xuICAud2l6YXJkLWltYWdlIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG5cbiAgLnN1bW1hcnktY29udGFpbmVyIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuXG59XG5cbi5zdW1tYXJ5LWNvbnRhaW5lciB7XG4gIG1heC13aWR0aDogNTAwcHg7XG59XG4vKiBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOjkwMHB4KSBhbmQgKG1heC13aWR0aDogMTAyNHB4KSB7XG4gIC5uZXdmbGV4Y29sLC5mbGV4Y29se3dpZHRoOiA0NiU7fVxuXG59ICovXG5cblxuLndpemFyZC1pbWFnZSBpbWcge1xuXG4gIC8qIG1hcmdpbi1yaWdodDogLTIwMCU7ICovXG4gIG1heC13aWR0aDogNDAwcHg7IGhlaWdodDogYXV0b1xufVxuXG5cbi5zbGlkZUluQW5pbWF0aW9uIHtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB6LWluZGV4OiAtMTtcbiAgcmlnaHQ6IC01MCU7XG4gIHRvcDogNTAlO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSg1MCUsLTUwJSkgc2NhbGVYKC0xKTtcbiAgLXdlYmtpdC1hbmltYXRpb246IHNsaWRlaW4gNHMgZm9yd2FyZHM7XG4gIGFuaW1hdGlvbjogc2xpZGVpbiA0cyBmb3J3YXJkcztcbn1cblxuLnNsaWRlT3V0QW5pbWF0aW9uIHtcbiAgLXdlYmtpdC1hbmltYXRpb246IHNsaWRlb3V0IDZzIGZvcndhcmRzO1xuICBhbmltYXRpb246IHNsaWRlb3V0IDZzIGZvcndhcmRzO1xufVxuXG5cbkBrZXlmcmFtZXMgc2xpZGVpbiB7XG4gIDEwMCUgeyByaWdodDogMjUwcHg7IH1cbn1cblxuXG5Aa2V5ZnJhbWVzIHNsaWRlb3V0IHtcbiAgMCUgeyByaWdodDogMjUwcHg7IH1cbiAgMTAwJSB7IHJpZ2h0OiA1MCU7IH1cbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/wizard/wizard-summary/wizard-summary.component.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;AAEF;;AAEA;EACE,gBAAgB;AAClB;AACA;;;GAGG;;;AAGH;;EAEE,yBAAyB;EACzB,gBAAgB,EAAE;AACpB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,QAAQ;EACR,yCAAyC;EAEzC,8BAA8B;AAChC;;AAEA;EAEE,+BAA+B;AACjC;;;AAGA;EACE,OAAO,YAAY,EAAE;AACvB;;;AAGA;EACE,KAAK,YAAY,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAAA,gxDAAgxD","sourcesContent":["@media screen and (max-width: 900px) {\n  .wizard-image {\n    display: none;\n  }\n\n  .summary-container {\n    width: 100%;\n  }\n\n}\n\n.summary-container {\n  max-width: 500px;\n}\n/* @media screen and (min-width:900px) and (max-width: 1024px) {\n  .newflexcol,.flexcol{width: 46%;}\n\n} */\n\n\n.wizard-image img {\n\n  /* margin-right: -200%; */\n  max-width: 400px; height: auto\n}\n\n\n.slideInAnimation {\n  position: absolute;\n  z-index: -1;\n  right: -50%;\n  top: 50%;\n  transform: translate(50%,-50%) scaleX(-1);\n  -webkit-animation: slidein 4s forwards;\n  animation: slidein 4s forwards;\n}\n\n.slideOutAnimation {\n  -webkit-animation: slideout 6s forwards;\n  animation: slideout 6s forwards;\n}\n\n\n@keyframes slidein {\n  100% { right: 250px; }\n}\n\n\n@keyframes slideout {\n  0% { right: 250px; }\n  100% { right: 50%; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
